import React from "react";
import "./Experience.css";
import Header from "../components/Header";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import exp from "../assets/experience.json";

const data = {
  heading: "Experience",
  image: "/images/education.svg",
  profile: "/images/pfp.jpeg",
};

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Header heading={data.heading} image={data.image} />
      <div className="exp-container">
        {exp.data.map((item) => (
          <div className="exp-item" key={item.id}>
            <h1>{item.name}</h1>

            <div className="spb">
              <h2>{item.role}</h2>
              <h3>{item.location}</h3>
            </div>
            <h3>
              {item.start} - {item.end}
            </h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
      <Link to="/" className="home">
        Home
      </Link>
    </motion.div>
  );
};

export default Experience;
